import React from "react";

import { RecentTips } from "./dashboard/RecentTips";
import { ContentDistributionChart } from "./dashboard/ContentDistributionChart";
import { KPICards } from "./dashboard/KPICards";
import { RecentFAQs } from "./dashboard/RecentFAQs";
import { TipsUtilityServiceChart } from "./dashboard/TipsUtilityServiceChart";
import { useDashboardDetails } from "../hooks";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";


export const SelfServiceDashboard = () => {
  const remoteUtilityId = getRemoteUtilityId();
  const { data: dashboardData } = useDashboardDetails({
    remote_utility_id: remoteUtilityId
  });

  const dashboardResult = dashboardData?.result;

  return (
    <div className="space-y-6">
      {/* Content Overview Stats */}
      <KPICards dashboardData={dashboardResult} />

      {/* Charts Row */}
      <div className="grid gap-6 md:grid-cols-2">
        <ContentDistributionChart dashboardData={dashboardResult} />
        <TipsUtilityServiceChart dashboardData={dashboardResult} />
      </div>

      {/* Bottom Row */}
      <div className="grid gap-6 md:grid-cols-2">
        <RecentFAQs dashboardData={dashboardResult} />
        <RecentTips dashboardData={dashboardResult} />
      </div>
    </div>
  );
};